/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, {
  forwardRef,
  useRef,
  useImperativeHandle,
  Fragment,
  useState,
  useEffect,
  useContext,
} from "react";
import { sanitizeImageUrl } from "../../utils/sanitizeImageUrl";
import { getBuyNowDisplayPrice } from "../../utils/listingPrice";
import { Row, Col } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import ImageGallery from "react-image-gallery";
import FeedbackContext from "../../context/cmscontext";
// import Magnifier from '../Magnifer/index'
import {
  AiFillCaretUp,
  AiFillCaretDown,
  AiFillHeart,
  AiOutlineHeart,
} from "react-icons/ai";
import {
  MdTitle,
  MdLastPage,
  MdGroups,
  MdAccountCircle,
  MdChevronLeft,
  MdChevronRight,
} from "react-icons/md";
import { ImHammer2 } from "react-icons/im";
import { RiReservedFill } from "react-icons/ri";
import { Divider } from "semantic-ui-react";
import TabExamplePointing from "./tabbar";
import Graph from "../Product View/graph";
import $ from "jquery";
import { connect } from "react-redux";
import Labels from "../../services/apiLabels";
import ScaleLoader from "react-spinners/ScaleLoader";
import Magnify from "./magnify";
import "./Productview.css";
import "../Product View/ProductDetail.css";
// import "./style.css";
// import "../../components/Magnifer/magnifier.css";
import Event from "../Magnifer/Event";
import Magnifier from "../Magnifer/Magnifier";
import {
  getProductCodeFromLocation,
  getListingPreviewFromLocation,
} from "../../utils/productLocation";
import {
  PLACE_BID,
  PRODUCT_DETAIL,
  TOASTER_SHOW,
  toaster_w,
  PRODUCT_DETAIL_BUY,
  SHIPING_COST,
} from "../../constant";
import { GET, POST } from "../../constant/apiMethods";
import carSvg from "../../assets/svg/car.svg";
import ProductMainShimmer from "./ProductMainShimmer";
import Tabs from "../TabsComponent";
import SlideButton from "../SlideButton";
import Carousel from "../Carousel";
import VehicleDetailsGrid from "../Product View/detailsGrid";
import { ClipboardDocumentCheckIcon } from "@heroicons/react/24/outline";
import { CarModal } from "./buyModal";

function ProductMain(props) {
  const {
    product,
    getProductDetail,
    place_bid,
    toasterShow,
    loadingPlaceBid,
    user_id,
    shiping_cost_calclate,
    loadingDetails,
  } = props;
  const graphRef = useRef();

  let location = useLocation();
  const productCode = getProductCodeFromLocation(location);
  const listingPreview = getListingPreviewFromLocation(location);

  // console.log"chk product id =======================>>>>>>>>>",productCode)
  const { feedback, isLoading } = useContext(FeedbackContext);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [bidInputValue, setBidInputValue] = useState(0);
  var auction_page = feedback.auction_page;
  const [bidInputFormated, setbidInputFormated] = useState({
    focused: false,
    formated: "0",
  });
  const [graphData, setGraphData] = useState({});
  const [bidingExpired, setBidingExpired] = useState(true);
  const [timer, setTimer] = useState([
    { id: "days", value: "00" },
    { id: "hours", value: "00" },
    { id: "minutes", value: "00" },
    { id: "seconds", value: "00" },
  ]);
  let history = useHistory();
  const [images, setImages] = useState([]);
  const [slideIndex, setSlideIndex] = useState(0);
  const [current_image, setcurrent_image] = useState("");
  // place bid inputs functions
  let bidAmountID = 1000;
  let [currentBid, setcurrentBid] = useState(0);
  const imageGalleryDataFormatter = (arr) => {
    let formattedArr = [];

    // arr.map((item) => {
    //   return formattedArr.push({
    //     image: item,
    //   });
    // });
    React.Children.toArray(
      arr.map((item, index) => {
        const clean = sanitizeImageUrl(item);
        return formattedArr.push({
          original: clean,
          thumbnail: clean,
          id: index + 1,
        });
      })
    );

    setImages(formattedArr);
  };
  const [isdone, setisdone] = useState(false);
  // price formater adding commas
  function priceFormater(numb) {
    var str = numb.toString();
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  // car animate handler
  const carAnimationHandler = () => {
    document.getElementById("animating_car_cont").className =
      "bid_animating_car_cont";
    setTimeout(() => {
      document.getElementById("animating_car_cont").className = "d-none";
    }, 3000);
  };
  // ================shiping valculate=============

  const [postCode, setpostCode] = useState("");

  const calculate_ = () => {
    shiping_cost_calclate({
      position1: product.post_code,
      position2: postCode,
      t_type: "open",
      pickup: false,
      type_of_car: "SUV",
      premium: false,
    });
  };

  useEffect(() => {
    if (!productCode) return;
    const params = new URLSearchParams(location.search || "");
    if (params.get("id") === String(productCode)) return;
    history.replace({
      pathname: location.pathname,
      search: `?id=${encodeURIComponent(productCode)}`,
      state: {
        ...(location.state || {}),
        product_code: productCode,
      },
    });
  }, [productCode, location.pathname, location.search, location.state, history]);

  useEffect(() => {
    if (productCode) {
      getProductDetail(productCode);
    }

    return () => {
      evt = new Event();
      m = new Magnifier(evt, {});
    };
  }, [productCode]);

  useEffect(() => {
    if (product?.images) imageGalleryDataFormatter(product.images);
    if (product?.start_price) {
      bidInputOnChangeHandler(product.start_price);
      setcurrentBid(product.start_price);
    }
    //
  }, [product]);
  // graph data handler
  useEffect(() => {
    let currentBidAmmount = graphData.cur_bid;
    if (currentBidAmmount) {
      if (currentBidAmmount > currentBid) {
        bidInputOnChangeHandler(currentBidAmmount);
        setcurrentBid(currentBidAmmount);
        carAnimationHandler();
      }
    }
  }, [graphData]);
  var evt = new Event();
  var m = new Magnifier(evt, {});
  // useEffect(() => {
  // // console.log
  //   "tag class ",
  //   document.getElementsByClassName(".center")[0].getElementsByTagName("img")[0]
  // );
  //   if (!isdone) {
  //     setisdone(true);
  //     m = new Magnifier(evt, {
  //       largeWrapper: document.getElementById("zoom-preview"),
  //     });

  //     m.attach({
  //       thumb: document
  //         .getElementsByClassName(".center")[0]
  //         .getElementsByTagName("img")[0],
  //       large: current_image,
  //       largeWrapper: "zoom-preview",
  //       zoom: 2,
  //       mode: "inside",
  //       zoomable: true,
  //       onthumbenter: function () {
  //         // document.getElementById("enter").innerHTML = "Mouse enter";
  //         // document.getElementById("leave").innerHTML = "";
  //         // document.getElementById("zoom").innerHTML = "";
  //         document.getElementById("zoom-preview").classList.remove("d-none");
  //       },
  //       onthumbmove: function () {
  //         // document.getElementById("move").innerHTML = "Mouse move";
  //         document.getElementById("zoom-preview").classList.remove("d-none");
  //       },
  //       onthumbleave: function () {
  //         // document.getElementById("enter").innerHTML = "";
  //         // document.getElementById("move").innerHTML = "";
  //         // document.getElementById("zoom").innerHTML = "";
  //         // document.getElementById("leave").innerHTML = "Mouse leave";
  //         document.getElementById("zoom-preview").classList.add("d-none");
  //       },
  //       // onzoom: function (data) {
  //       //   document.getElementById("zoom").innerHTML = "Zoom: " + data.zoom;
  //       // },
  //     });
  //   } else {
  //     m.setThumb(
  //       document
  //         .getElementsByClassName(".center")[0]
  //         .getElementsByTagName("img")[0]
  //     );
  //   }
  // }, [current_image]);
  // --------------timer
  // let countDownDate = new Date().getTime() + 10000;
  //
  const timeFormatter = (e) => {
    return e < 10 ? `0${e}` : e;
  };
  const screen_change = (e) => {
    m.leaver();
    document.getElementById("zoom-preview").classList.add("d-none");
    //

    if (e) {
      m.attach({
        thumb: ".image-gallery-image",
        // document
        //   .getElementsByClassName("center")[0]
        //   .getElementsByTagName("img")[0],
        // large: current_image,
        largeWrapper: "zoom-preview",
        zoom: 2,
        mode: "inside",
        zoomable: true,
        onthumbenter: function () {
          // document.getElementById("enter").innerHTML = "Mouse enter";
          // document.getElementById("leave").innerHTML = "";
          // document.getElementById("zoom").innerHTML = "";
          // document.getElementById("zoom-preview").classList.remove("d-none");
        },
        onthumbmove: function () {
          // document.getElementById("move").innerHTML = "Mouse move";
          // document.getElementById("zoom-preview").classList.remove("d-none");
        },
        onthumbleave: function () {
          // document.getElementById("enter").innerHTML = "";
          // document.getElementById("move").innerHTML = "";
          // document.getElementById("zoom").innerHTML = "";
          // document.getElementById("leave").innerHTML = "Mouse leave";
          // document.getElementById("zoom-preview").classList.add("d-none");
        },
        // onzoom: function (data) {
        //   document.getElementById("zoom").innerHTML = "Zoom: " + data.zoom;
        // },
      });
    } else {
      //
      m.attach({
        thumb: ".image-gallery-image",
        // document
        //   .getElementsByClassName("center")[0]
        //   .getElementsByTagName("img")[0],
        // large: current_image,
        largeWrapper: "zoom-preview",
        zoom: 2,
        mode: "inside",
        zoomable: true,
        onthumbenter: function () {
          // document.getElementById("enter").innerHTML = "Mouse enter";
          // document.getElementById("leave").innerHTML = "";
          // document.getElementById("zoom").innerHTML = "";
          document.getElementById("zoom-preview").classList.remove("d-none");
        },
        onthumbmove: function () {
          // document.getElementById("move").innerHTML = "Mouse move";
          document.getElementById("zoom-preview").classList.remove("d-none");
        },
        onthumbleave: function () {
          // document.getElementById("enter").innerHTML = "";
          // document.getElementById("move").innerHTML = "";
          // document.getElementById("zoom").innerHTML = "";
          // document.getElementById("leave").innerHTML = "Mouse leave";
          document.getElementById("zoom-preview").classList.add("d-none");
        },
        // onzoom: function (data) {
        //   document.getElementById("zoom").innerHTML = "Zoom: " + data.zoom;
        // },
      });
    }
    m.set_data();
    //  m = new Magnifier(evt, {
    //    largeWrapper: document.getElementById("zoom-preview"),
    //  });
    // m.setThumb(document
    //         .getElementsByClassName("center")[0]
    //         .getElementsByTagName("img")[0]);
  };
  const set_magnifier = (e) => {
    if (!isdone) {
      setisdone(true);
      // m = new Magnifier(evt, {
      //   largeWrapper: document.getElementById("zoom-preview"),
      // });
      m.attach({
        thumb: ".image-gallery-image",
        // document
        //   .getElementsByClassName("center")[0]
        //   .getElementsByTagName("img")[0],
        // large: current_image,
        largeWrapper: "zoom-preview",
        zoom: 2,
        mode: "inside",
        zoomable: true,
        onthumbenter: function () {
          // document.getElementById("enter").innerHTML = "Mouse enter";
          // document.getElementById("leave").innerHTML = "";
          // document.getElementById("zoom").innerHTML = "";
          var ab = document.getElementById("zoom-preview");
          if (ab) {
            ab.classList.remove("d-none");
          }
          // document.getElementById("zoom-preview").classList.remove("d-none");
        },
        onthumbmove: function () {
          // document.getElementById("move").innerHTML = "Mouse move";
          var ab = document.getElementById("zoom-preview");
          if (ab) {
            ab.classList.remove("d-none");
          }
          // document.getElementById("zoom-preview").classList.remove("d-none");
        },
        onthumbleave: function () {
          // document.getElementById("enter").innerHTML = "";
          // document.getElementById("move").innerHTML = "";
          // document.getElementById("zoom").innerHTML = "";
          // document.getElementById("leave").innerHTML = "Mouse leave";
          var ab = document.getElementById("zoom-preview");
          if (ab) {
            ab.classList.add("d-none");
          }
        },
        // onzoom: function (data) {
        //   document.getElementById("zoom").innerHTML = "Zoom: " + data.zoom;
        // },
      });
    }
  };
  useEffect(() => {
    let countDownDate = new Date(product.end_at ? product.end_at : 0).getTime();
    const interval = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimer([
        { id: "days", value: timeFormatter(days) },
        { id: "hours", value: timeFormatter(hours) },
        { id: "minutes", value: timeFormatter(minutes) },
        { id: "seconds", value: timeFormatter(seconds) },
      ]);
      setBidingExpired(false);
      // If the count down is over, write some text
      if (distance < 0) {
        clearInterval(interval);
        setBidingExpired(true);
        setTimer([
          { id: "days", value: "00" },
          { id: "hours", value: "00" },
          { id: "minutes", value: "00" },
          { id: "seconds", value: "00" },
        ]);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [product]);
  // --------------timer

  // ==========aprocxy bid==========

  const approxy_bid = async () => {
    let obj = {
      date: new Date(),
      auction_id: product.auction_id,
      user_id,
      bid_amount: bidInputValue,
      bid_type: "2",
    };

    place_bid(obj);
    await graphRef.current.fetchGraphData();
    return "bid placed";
  };

  // place bid handler
  const placeBidHandler = async () => {
    if (bidInputValue > currentBid) {
      let obj = {
        date: new Date(),
        auction_id: product.auction_id,
        user_id,
        bid_amount: bidInputValue,
        bid_type: "1",
      };
      //
      await place_bid(obj);
      await graphRef.current.fetchGraphData();
      return "bid placed";
    } else {
      toasterShow({
        type: toaster_w,
        description: `Bidding amount must be greater then ${currentBid}`,
      });
      return "bid not placed";
    }
  };
  const bidInputOnChangeHandler = (e) => {
    if (e) {
      setBidInputValue(e);
      setbidInputFormated({ ...bidInputFormated, formated: priceFormater(e) });
    }
  };
  const vehicleDetails = [
    { name: "Make", value: product?.product_name },
    { name: "Model", value: product?.model_name },
    { name: "Year", value: product?.year },
    { name: "Price", value: product?.poa ? "POA" : getBuyNowDisplayPrice(product, { buyNowFloor: true }) },
    { name: "Mileage", value: product?.Mileage },
    { name: "Fuel Type", value: product?.fuel_type },
    {
      name: "Transmission",
      value:
        product?.Transmission == 1
          ? "Auto"
          : product?.Transmission == 2
          ? "Manual"
          : "Both",
    },
    {
      name: "Body Type",
      value:
        product?.car_body_type == 1
          ? "Hatchback"
          : product?.car_body_type == 2
          ? "MPV"
          : product?.car_body_type == 3
          ? "SUV"
          : "Saloon",
    },
    { name: "Registration", value: product?.Registration },
    { name: "VAT", value: product?.vat },
  ];
  // document
  //   .getElementByClassName("image-gallery-fullscreen-button")[0]
  //   .addEventListener("click", changeObjectFitHandler);
  // function changeObjectFitHandler() {
  //   let image = document.getElementsByClassName("img")[0];
  //   let style = window.getComputedStyle(image);
  //   let objectFit = style.getPropertyValue("object-fit");
  //   if (objectFit === "contain") {
  //     image.style.objectFit = "cover";
  //   }
  //   if (objectFit === "cover") {
  //     image.style.objectFit = "contain";
  //   }
  //
  // }
  useEffect(() => {
    // console.log"testingggg bidInputValue", parseInt(bidInputValue));
  }, [bidInputValue, bidInputFormated]);
  // loadingDetails
  if (loadingDetails) {
    return <ProductMainShimmer />;
  }

  const goBack = () => {
    if (history.length > 1) history.goBack();
    else history.push("/dealers/dashbord");
  };

  const pageClass = "dp-page dp-page--embedded";

  const hasProductDetail = Boolean(
    product &&
      (product.id ||
        product.product_name ||
        product.auction_id ||
        (Array.isArray(product.images) && product.images.length))
  );

  if (!productCode) {
    return (
      <Fragment>
        <div className={pageClass}>
          <div className="dp-page__inner">
            <header className="dp-topbar">
              <button type="button" className="dp-btn dp-btn--ghost" onClick={goBack}>
                ← Back
              </button>
              <div className="dp-topbar__meta">
                <span className="dp-chip dp-chip--buy">Buy now</span>
              </div>
            </header>
            <div className="dp-panel dp-empty">
              <h1 className="dp-empty__title">No lot selected</h1>
              <p className="dp-empty__text">
                Open a listing from favourites, watchlist, or buy now floor.
              </p>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  if (!hasProductDetail) {
    const reg =
      listingPreview?.registration ||
      product?.Registration ||
      product?.registration ||
      "—";
    const vehicle =
      listingPreview?.product_name ||
      listingPreview?.vehicle ||
      product?.product_name ||
      "Vehicle details unavailable";
    const price = getBuyNowDisplayPrice(
      {
        ...product,
        ...listingPreview,
        buy_now: true,
        buy_now_price:
          listingPreview?.buy_now_price ??
          product?.buy_now_price,
        product_price: listingPreview?.product_price ?? product?.product_price,
        price: listingPreview?.price ?? product?.price,
      },
      { buyNowFloor: true }
    );
    return (
      <Fragment>
        <div className={pageClass}>
          <div className="dp-page__inner">
            <header className="dp-topbar">
              <button type="button" className="dp-btn dp-btn--ghost" onClick={goBack}>
                ← Back
              </button>
              <div className="dp-topbar__meta">
                <span className="dp-chip dp-chip--buy">Buy now</span>
              </div>
            </header>
            <div className="dp-panel dp-empty">
              <div className="dp-plate">
                <span className="dp-plate__badge" aria-hidden>
                  ATP
                </span>
                <div className="dp-plate__text">{String(reg).toUpperCase()}</div>
              </div>
              <h1 className="dp-empty__title">{vehicle}</h1>
              <p className="dp-empty__text">
                Full listing details could not be loaded for this lot.
                Showing the summary from your list where available.
              </p>
              <table className="dp-summary">
                <tbody>
                  {price != null && price !== "" ? (
                    <tr>
                      <th>Price</th>
                      <td>€{Number(price).toLocaleString()}</td>
                    </tr>
                  ) : null}
                  {listingPreview?.product_description ? (
                    <tr>
                      <th>Description</th>
                      <td>{String(listingPreview.product_description)}</td>
                    </tr>
                  ) : null}
                  <tr>
                    <th>Product ID</th>
                    <td>{String(productCode)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  return (
      <Fragment>
        <div className={pageClass}>
          <div className="dp-page__inner">
            <header className="dp-topbar">
              <button type="button" className="dp-btn dp-btn--ghost" onClick={goBack}>
                ← Back
              </button>
              <div className="dp-topbar__meta">
                <span className="dp-chip dp-chip--buy">Buy now</span>
              </div>
            </header>

            <div className="dp-hero">
              <div className="dp-panel">
                <section className="dp-media">
                  <header className="dp-media__head">
                    <div>
                      <p className="dp-media__eyebrow">Lot gallery</p>
                      <h3 className="dp-media__title">Vehicle photos</h3>
                    </div>
                    <span className="dp-media__counter">
                      {images.length
                        ? `${Math.min(slideIndex + 1, images.length)} / ${
                            images.length
                          }`
                        : "No photos"}
                    </span>
                  </header>
                  <div className="dp-gallery slider_">
                    {images.length ? (
                      <ImageGallery
                        lazyLoad={false}
                        onImageLoad={set_magnifier}
                        onSlide={setSlideIndex}
                        startIndex={0}
                        items={images}
                        showBullets={false}
                        showPlayButton={false}
                        showFullscreenButton={false}
                        showIndex={false}
                        thumbnailPosition="bottom"
                        slideDuration={320}
                        originalClass="ImageGallery_originalClass"
                        renderLeftNav={(onClick, disabled) => (
                          <button
                            type="button"
                            className="dp-gallery__nav dp-gallery__nav--prev"
                            onClick={onClick}
                            disabled={disabled}
                            aria-label="Previous photo"
                          >
                            <MdChevronLeft size={24} aria-hidden />
                          </button>
                        )}
                        renderRightNav={(onClick, disabled) => (
                          <button
                            type="button"
                            className="dp-gallery__nav dp-gallery__nav--next"
                            onClick={onClick}
                            disabled={disabled}
                            aria-label="Next photo"
                          >
                            <MdChevronRight size={24} aria-hidden />
                          </button>
                        )}
                      />
                    ) : (
                      <p className="dp-gallery__empty">
                        No photos have been uploaded for this lot yet.
                      </p>
                    )}
                    <div
                      className="magnifier-preview d-none"
                      id="zoom-preview"
                      aria-hidden="true"
                    />
                  </div>
                </section>
                <div className="dp-shipping">
                  <h3 className="dp-panel__title">{auction_page.Shiping_Charges}</h3>
                  <p className="dp-panel__hint">{auction_page.Enter_Your_Post_Code}</p>
                  <div className="dp-shipping__row">
                    <input
                      onChange={(e) => setpostCode(e.target.value)}
                      className="dp-input"
                      placeholder={auction_page.LEG321_placeholder}
                    />
                    <button type="button" className="dp-btn dp-btn--primary" onClick={calculate_}>
                      Calculate
                    </button>
                  </div>
                </div>
              </div>

              <div className="dp-aside">
                <div className="dp-panel cardetailmain">
                  {product ? (
                    <div className="dp-identity">
                      {product?.brands_image ? (
                        <img
                          src={sanitizeImageUrl(product?.brands_image)}
                          className="dp-identity__brand"
                          alt=""
                        />
                      ) : null}
                      <div className="dp-plate">
                        <span className="dp-plate__badge" aria-hidden>
                          ATP
                        </span>
                        <div className="dp-plate__text">
                          {(product?.Registration || product?.registration || "—")
                            .toString()
                            .toUpperCase()}
                        </div>
                      </div>
                      <h1 className="dp-identity__title">
                        {`${product?.product_name || ""} ${product?.year || ""} ${
                          product?.fuel_type || ""
                        }`.trim()}
                      </h1>
                      <button
                        type="button"
                        className="dp-btn dp-btn--primary dp-buy-cta"
                        onClick={handleShow}
                      >
                        Buy Now
                      </button>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="dp-details dp-panel">
              <div className="dp-details__head">
                <p className="dp-details__eyebrow">Inspection & disclosures</p>
                <h2>Vehicle details</h2>
                <p className="dp-details__lead">
                  History report and lot disclosures for this vehicle.
                </p>
                <div className="dp-report">
                  <ClipboardDocumentCheckIcon width={42} />
                  <div className="dp-report__copy">
                    <h3>Vehicle History Report</h3>
                    <p>Powered by VMS</p>
                  </div>
                  <button
                    type="button"
                    className="dp-btn dp-btn--primary"
                    onClick={() => {
                      history.push({
                        pathname: "/dealers/dashbord/carreport",
                        search: `?id=${encodeURIComponent(productCode)}`,
                        state: {
                          product_code: productCode,
                          pdfSnapshot: {
                            product_name: product?.product_name || "",
                            year: product?.year || "",
                            Mileage: product?.Mileage || product?.mileage || "",
                            fuel_type: product?.fuel_type || "",
                            Transmission: product?.Transmission ?? "",
                            car_body_type: product?.car_body_type ?? "",
                            brands_image: product?.brands_image || "",
                          },
                        },
                      });
                    }}
                  >
                    View report
                  </button>
                </div>
                <h3 className="dp-details__subhead">Details & disclosures</h3>
              </div>
              <div className="dp-details__body">
                <VehicleDetailsGrid
                  title={"Car Details"}
                  bg={false}
                  details={vehicleDetails}
                />
                {product?.product_accessory?.length > 0 && (
                  <VehicleDetailsGrid
                    title={"Car Accessories"}
                    bg={true}
                    details={product.product_accessory}
                  />
                )}
                {product?.product_feature?.length > 0 && (
                  <VehicleDetailsGrid
                    title={"Car Features"}
                    bg={false}
                    details={product.product_feature}
                  />
                )}
                {product?.product_description && (
                  <VehicleDetailsGrid
                    title={"Comments"}
                    bg={true}
                    comments={product.product_description}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <CarModal show={show} handleClose={handleClose} car={{...product,shippingCharges:500}} />
      </Fragment>
    );
}

const mapStateToProps = (state) => ({
  user_id: state.auth.id,
  product: state.product.current,
  loadingDetails: state.product.fetchingCurrent,
  loadingPlaceBid: state.product.loadingPlaceBid,
  shiping_coast_: state.shiping,
});
const mapDispatchToProps = (dispatch) => ({
  // get product list
  getProductDetail: (code) =>
    dispatch({
      type: PRODUCT_DETAIL,
      payload: {
        type: PRODUCT_DETAIL,
        method: GET,
        label: `${Labels.product_detail}${code}/`,
        hideOverlayLoader: true,
      },
    }),
  //
    //  get shiping cost
    shiping_cost_calclate: (data) =>
      dispatch({
        type: SHIPING_COST,
        payload: {
          type: SHIPING_COST,
          method: POST,
          label: `${Labels.shiping_cost}`,
          data,
          hideOverlayLoader: true,
        },
      }),
  // place bid
  place_bid: (data) =>
    dispatch({
      type: PLACE_BID,
      payload: {
        type: PLACE_BID,
        method: POST,
        label: `${Labels.place_bid}`,
        data,
        hideOverlayLoader: true,
      },
    }),
  //
  toasterShow: (data) =>
    dispatch({
      type: TOASTER_SHOW,
      payload: {
        show: true,
        autoHide: true,
        ...data,
      },
    }),
});
export default connect(mapStateToProps, mapDispatchToProps)(ProductMain);
